export const ROUTE_PATHS = {
  HOME: '/',
  LOGIN: '/login',
  // Where the server answers a sign-in made through the identity provider. The backend builds
  // this address too (`ssoClientCallbackPath`), so the two change together.
  SSO_CALLBACK: '/sso/callback',
  FOLDERS: '/folders',
  // Projects live at the leaf of their folder path, so one splat serves the folder listing
  // and the project page alike; @lib/routing/projectPath tells them apart and builds them.
  FOLDER: '/folders/*',
  VIEWER_FOLDER: '/viewer/folders/*',
  PROJECTS: '/projects',
  // Kept so links minted before projects moved under the folder tree still resolve; both
  // redirect to the path-bearing URL.
  LEGACY_PROJECT: '/projects/:projectId/*',
  LEGACY_VIEWER_PROJECT: '/viewer/projects/:projectId/*',
  // Every inspection the reader may see, filtered: the list Home previews, at length. A
  // single inspection is still addressed under its project, never under this path.
  INSPECTIONS: '/inspections',
  // Where that list lived before it had a menu entry and filters; kept so older links
  // resolve, and redirects to it.
  LEGACY_RECENT_INSPECTIONS: '/recent-inspections',
  USERS: '/users',
  TEAMS: '/teams',
  TEAM_DETAIL: '/teams/:teamId',
  SETTINGS: '/settings',
  // Customization is a section: the POI type catalog, the app's settings, the report designs
  // and the report's brand.
  CUSTOMIZATIONS_POI_TYPES: '/customizations/poi-types',
  // A type's fields and groups live on its own page; the list stays a list.
  CUSTOMIZATIONS_POI_TYPE: '/customizations/poi-types/:poiTypeId',
  // The SuPAR app's default settings for a team, the team in `?team=`.
  CUSTOMIZATIONS_APP_SETTINGS: '/customizations/app-settings',
  // The layouts authors compose for the PDF inspection report, for whoever may edit one.
  CUSTOMIZATIONS_REPORT_DESIGNS: '/customizations/report-designs',
  // A design is composed on its own page; the list stays a list.
  CUSTOMIZATIONS_REPORT_DESIGN: '/customizations/report-designs/:designId',
  // The brand reports are printed with: the organization's (`?scope=organization`) or a
  // team's (`?team=`). It is one for every layout that takes it, and `?layout=` only says
  // which of them the preview shows it on.
  CUSTOMIZATIONS_REPORT_BRANDING: '/customizations/report-branding',
  SERVER_CONFIG: '/server-config',
  NOT_FOUND: '*'
} as const;

export type RoutePaths = typeof ROUTE_PATHS[keyof typeof ROUTE_PATHS];
